<template>
  <el-card>
    <el-form
        v-loading="loading"
        ref="ruleForm"
        :rules="rules"
        :model="form"
        label-width="80px"
    >
      <el-form-item label="轮播名称" prop="name" style="width: 600px;">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="开始时间" style="width: 600px;" prop="startTime">
        <el-date-picker
            type="datetime"
            placeholder="开始时间"
            v-model="form.startTime"
            :picker-options="pickerStartOptions"
            style="width: 100%;"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间" style="width: 600px;" prop="endTime">
        <el-date-picker
            type="datetime"
            placeholder="结束时间"
            v-model="form.endTime"
            :picker-options="pickerOptions"
            style="width: 100%;"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="图片上传" prop="path">
        <el-upload
            :action="uploadPath"
            list-type="picture-card"
            :auto-upload="true"
            :headers="headers"
            :on-success="handleSuccess"
            :data="uploadParam"
            accept=".jpg,.jpeg,.png,.gif,.svg"
            :beforeUpload="beforeBannerUpload"
            :limit="1"
            :file-list="fileList"
        >
          <i class="el-icon-plus"></i>
          <div slot="file" slot-scope="{ file }">
            <img class="el-upload-list__item-thumbnail" :src="file.url"/>
            <span class="el-upload-list__item-actions">
              <span
                  class="el-upload-list__item-preview"
                  @click="handlePictureCardPreview(file)"
              >
                <i class="el-icon-zoom-in"></i>
              </span>
              <span
                  v-if="!disabled"
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file)"
              >
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
          <div slot="tip" class="el-upload__tip">
            建议上传文件大小不超过500K，尺寸(750 × 925)
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="权重" prop="weight">
        <el-input-number
            v-model="form.weight"
            :min="0"
            :max="255"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="显示位置">
        <el-select v-model="form.location" placeholder="显示位置">
          <el-option
              v-for="item in BANNER_LOCATION.options()"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
          label="链接类型"
          :required="false"
          prop="srcType"
          style="width: 600px;"
      >
        <el-select
            v-model="form.srcType"
            style="width: 100%"
            clearable
            placeholder="请选择"
        >
          <el-option
              v-for="item in srcType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <div v-if="form.srcType">
        <el-form-item
            label=""
            :required="false"
            prop="miniType"
            style="width: 600px;"
            v-if="form.srcType === 2"
        >
          <el-radio-group v-model="form.miniType">
            <el-radio
                v-for="(item, index) in miniType"
                :key="index"
                :label="item.value"
            >{{ item.label }}
            </el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item
            v-if="form.miniType === 1 && form.srcType === 2"
            label="APPID"
            prop="appId"
            style="width: 600px;"
        >
          <el-input v-model="form.appId"></el-input>
        </el-form-item>

        <el-form-item label="链接地址" prop="linkSrc" style="width: 600px;">
          <el-input v-model="form.linkSrc"></el-input>
        </el-form-item>
      </div>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </el-form-item>
    </el-form>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt=""/>
    </el-dialog>
  </el-card>
</template>

<script>
import _ from "lodash";
import store from "@/store";
import {createNamespacedHelpers} from "vuex";
import {dateToString} from "@/helpers";
import {BANNER_LOCATION} from "@/enums/bannerStatus";

const {mapGetters} = createNamespacedHelpers("banners");

export default {
  data() {
    return {
      loading: false,
      isEdit: false,
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      fileList: [],
      uploadParam: {
        width: 750,
        folder: "banners",
        type: 'image'
      },
      form: {
        name: "",
        startTime: "",
        endTime: "",
        path: "",
        type: 0,
        weight: 0,
        src: {},
        linkSrc: "",
        srcType: "",
        miniType: 1,
        appId: "",
        location: 'home'
      },
      srcType: [
        {value: 1, label: "HTML链接"},
        {value: 2, label: "小程序链接"},
      ],
      miniType: [
        {value: 1, label: "外部小程序"},
        {value: 2, label: "内部小程序"},
      ],

      BANNER_LOCATION
    };
  },
  computed: {
    uploadPath() {
      return this.$config.api.baseURL + "/upload";
    },
    headers() {
      const {token} = store.state.auth;
      return {
        Authorization: `Bearer ${token}`,
      };
    },
    pickerOptions() {
      return {
        disabledDate: (time) => {
          return time.getTime() < Date.parse(this.form.startTime);
        },
      };
    },
    pickerStartOptions() {
      return {
        disabledDate: (time) => {
          return time.getTime() > Date.parse(this.form.endTime);
        },
      };
    },
    rules() {
      const rules = {
        name: [{required: true, message: "请填写轮播名称", trigger: "blur"}],
        path: [{required: true, message: "图片必须上传", trigger: "blur"}],
        startTime: [
          {required: true, message: "请输入开始日期", trigger: "blur"},
        ],
        endTime: [
          {required: true, message: "请输入结束日期", trigger: "blur"},
        ],
        appId: [
          {required: true, message: "请填写小程序APPID", trigger: "blur"},
        ],
        linkSrc: [
          {required: true, message: "请填写链接地址", trigger: "blur"},
        ],
        weight: [
          {
            validator: (rule, value, callback) => {
              if (
                  this.form.weight == undefined ||
                  this.form.weight < 0 ||
                  this.form.weight > 255
              ) {
                callback(new Error("权重设置范围在0-255之间,请确认"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      };
      return rules;
    },
    ...mapGetters(["document"]),
  },
  methods: {
    async onSubmit() {
      console.log(this.getSubmitForm());
      try {
        await new Promise((resovle, reject) => {
          this.$refs["ruleForm"].validate((valid) => {
            valid ? resovle(true) : reject(false);
          });
        });
      } catch (e) {
        return false;
      }
      const formData = this.getSubmitForm();
      const {srcType, appId, linkSrc, miniType} = formData;
      formData.src = {
        srcType,
        appId,
        linkSrc,
        miniType,
      };
      delete formData.srcType;
      delete formData.appId;
      delete formData.linkSrc;
      delete formData.miniType;
      try {
        await this.$store.dispatch(
            this.isEdit ? "banners/update" : "banners/create",
            formData
        );
        this.loading = false;
        this.$message.success("提交成功");
        this.$router.push("/settings/banner-list");
        let path = "";
        if (this.$enums.bannerTypes.CardIndex == this.form.type) {
          path = "/settings/banner-list";
        } else {
          console.log('cs')
          path = "/settings/cs-banner-list";
        }
        this.$router.push(path);
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },
    getSubmitForm() {
      const submitForm = _.cloneDeep(this.form);

      submitForm.startTime = dateToString(submitForm.startTime);
      submitForm.endTime = dateToString(submitForm.endTime);
      return submitForm;
    },
    handleRemove() {
      this.fileList = [];
      this.form.path = "";
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSuccess(res, file) {
      this.fileList.push(file);
      this.form.path = res.data.path;
      this.loading = false;
    },
    beforeBannerUpload(file) {
      const isLt4M = file.size / 1024 / 1024 <= 50;
      if (!isLt4M) {
        this.$message.warning("图片大小不能超过50M");
        return false;
      }
      this.loading = true;
    },
    initForm() {
      const document = _.cloneDeep(this.document);

      this.form = _.cloneDeep(document);
      this.fileList = [{name: this.form.path, url: this.form.imageUrl}];
      if (!this.form.urlType) {
        this.form.urlType = undefined;
      }

      if (this.form.src.srcType) {
        this.$set(this.form, "srcType", this.form.src.srcType);
        this.$set(this.form, "appId", this.form.src.appId);
        this.$set(this.form, "linkSrc", this.form.src.linkSrc);
        this.$set(this.form, "miniType", this.form.src.miniType);
      }

      delete this.form.extension;
    },
  },

  async mounted() {
    const {id} = this.$route.query;
    this.form.type = this.$route.meta.type;
    if (id > 0) {
      this.isEdit = true;
    }
    if (this.isEdit) {
      const {document} = await this.$store.dispatch("banners/document", id);
      this.initForm();
    }
  },
};
</script>
